import ReactMarquee from "react-fast-marquee";

const ITEMS = ["AI Education", "Soft Life", "Women in Tech", "Automated & Fabulous"];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative py-8 md:py-10 border-t border-b border-[#1A1A1A]/10"
      style={{ background: "#F2EBE5" }}
      aria-label="Findaura values marquee"
    >
      <ReactMarquee speed={35} gradient={false} pauseOnHover={false}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center">
            {ITEMS.map((item, j) => (
              <span key={`${i}-${j}`} className="flex items-center">
                <span className="marquee-text text-3xl md:text-5xl px-8 md:px-12">{item}</span>
                <span className="text-[#C28C55] text-2xl">·</span>
              </span>
            ))}
          </div>
        ))}
      </ReactMarquee>
    </section>
  );
}
